<div id="additional-certificates-table">
    <div class="card-panel">
        <app-section-title
            [sectionTitleConfig]="sectionTitleConfig"
        ></app-section-title>
    </div>
    <table
        mat-table
        [dataSource]="this.tableDataSource"
        class="mat-eleveation-z8"
    >
        <ng-container matColumnDef="documentType">
            <th mat-header-cell *matHeaderCellDef class="document-type-header">Τύπος Δικαιολογητικού</th>
            <td mat-cell *matCellDef="let element">
                <mat-form-field class="mt-4" [formGroup]="element">
                    <mat-label>Τύπος Δικαιολογητικού</mat-label>
                    <mat-select formControlName="documentType">
                        <mat-option
                            *ngFor="let opt of documentTypes"
                            [value]="opt"
                            >{{ opt }}</mat-option
                        >
                    </mat-select>
                    <mat-error *ngIf="element.get('documentType').invalid">
                      Επιλέξτε Τύπο Δικαιολογητικού
                    </mat-error>
                </mat-form-field>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center document-action-header">Ενέργεια</th>
            <td mat-cell *matCellDef="let element; let i = index">
                <ng-container [formGroup]="element">
                    <div class="row text-right">
                        <div
                            class="col-12 w-12"
                            *ngFor="let btn of buttonConfigMap.get(element.get('documentId').value);"
                        >
                            <app-button
                                [actionCallback]="btn.actionCallback"
                                [label]="btn.label"
                                [hint]="btn.hint"
                                [otherProperties]="element.getRawValue()"
                                [classes]="btn.classes"
                                [disabled]="btn.disabled"
                            ></app-button>
                        </div>
                    </div>
                </ng-container>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns" class="mt-3"></tr>
        <tr mat-row *matRowDef="let row; columns: columns" class="mt-3"></tr>
    </table>
    <div class="row mt-3">
      <div class="col-12 text-right">
        <button class="btn btn-secondary table-button" (click)="addRow()">Προσθήκη Νέου (+)</button>
      </div>
    </div>
</div>

<input
      type="file"
      #inputFile
      hidden
      (change)="handleFileInput($event.target.files)"
    />
